//
//  DocumentationLegacyPageBlockFiles.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//  Copyright © 2021 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
export class DocumentationLegacyPageBlockFiles extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a;
        super(model, children);
        this.files = ((_a = model.files) !== null && _a !== void 0 ? _a : []).map((f) => {
            var _a, _b, _c, _d;
            return {
                entityId: f.entityId,
                entityMeta: {
                    title: (_b = (_a = f.entityMeta) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : null,
                    description: (_d = (_c = f.entityMeta) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : null,
                },
            };
        });
    }
}
